import { render, staticRenderFns } from "./termsAndConditions.vue?vue&type=template&id=f0c5f5e4&scoped=true"
var script = {}
import style0 from "./termsAndConditions.vue?vue&type=style&index=0&id=f0c5f5e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0c5f5e4",
  null
  
)

export default component.exports